import SettingsStore from '../../settings/SettingsStore';

import initTPAViewModeSite from './initTPAViewModeSite';
import initTPAViewModeStandalone from './initTPAViewModeStandalone';
import initTPAViewModeEditor from './initTPAViewModeEditor';
import initTPAViewModeDevEditor from './initTPAViewModeDevEditor';

import { ITPAParams, TPAViewMode } from '@wix/podcasts-common/dist/tpa';

function initTPAViewMode(tpaParams: ITPAParams, settingsStore: SettingsStore) {
  switch (tpaParams.viewMode) {
    case TPAViewMode.SITE:
      return initTPAViewModeSite();

    case TPAViewMode.EDITOR:
      return initTPAViewModeEditor(tpaParams, settingsStore);

    case TPAViewMode.DEV_EDITOR:
      return initTPAViewModeDevEditor(tpaParams, settingsStore);

    default:
      return initTPAViewModeStandalone();
  }
}

export default initTPAViewMode;
